import { render } from "./QuestBook.vue?vue&type=template&id=0c83a777"
import script from "./QuestBook.vue?vue&type=script&lang=js"
export * from "./QuestBook.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/QuestBook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c83a777"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c83a777', __exports__)) {
    api.reload('0c83a777', __exports__)
  }
  
  module.hot.accept("./QuestBook.vue?vue&type=template&id=0c83a777", () => {
    api.rerender('0c83a777', render)
  })

}


export default __exports__